import { render, staticRenderFns } from "./DetailsViewOnlyPage.vue?vue&type=template&id=74860d6e&scoped=true&"
import script from "./DetailsViewOnlyPage.vue?vue&type=script&lang=js&"
export * from "./DetailsViewOnlyPage.vue?vue&type=script&lang=js&"
import style0 from "./DetailsViewOnlyPage.vue?vue&type=style&index=0&id=74860d6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74860d6e",
  null
  
)

export default component.exports